interface RuntimeConfig {
  msalClientId: string
  msalTenantId: string
  apimBaseUrl: string
  msalApiScope: string
}

let configCache: RuntimeConfig | null = null
let configLoadAttempted = false

export const loadRuntimeConfig = async (): Promise<RuntimeConfig | null> => {
  if (configCache) {
    return configCache
  }

  if (configLoadAttempted) {
    return null
  }

  configLoadAttempted = true

  try {
    const response = await fetch('/config.json')
    if (!response.ok) {
      console.warn('config.json not found, will use build-time environment variables')
      return null
    }

    const config = (await response.json()) as RuntimeConfig

    if (
      !config.msalClientId ||
      !config.msalTenantId ||
      !config.apimBaseUrl ||
      !config.msalApiScope
    ) {
      console.warn('config.json has empty values, will use build-time environment variables')
      return null
    }

    configCache = config
    return config
  } catch (error) {
    console.warn(
      'Failed to load runtime configuration, will use build-time environment variables:',
      error,
    )
    return null
  }
}

export const getRuntimeConfig = (): RuntimeConfig | null => {
  return configCache
}
